<div class="roi-presentation" style="padding-bottom: 2rem;">
  <div class="row">
    <div class="column medium-12 text-center">
      <span style="font-size: 30px;" [ngStyle]="{'color': disablePrevButton ? '#878787':'#808cc5'}"><i class="icon ion-android-arrow-dropleft-circle" (click)="showPreviousSlide()"></i></span>
      <span style="font-size: 30px;" [ngStyle]="{'color': disableNextButton ? '#878787':'#808cc5'}"><i class="icon ion-android-arrow-dropright-circle" (click)="showNextSlide()"></i></span>
      <span class="float-right" *ngIf="!readOnly">
        <button type="button" class="button" style="margin-bottom: 0; white-space: nowrap;" (click)="exportToPPT()">Download PowerPoint</button>
      </span>
    </div>
  </div>
  <div class="row slide slide-1 d-flex align-items-center" id="slide-1"
       *ngIf="slideLoaded && currentSlide == 'slide-1'">
    <div class="horizontal-bar d-flex ps-5 flex-column">
      <div class="org-logo" [ngStyle]="logoBg"></div>
      <span class="title mt-2">Tax Planning Proposal</span>
      <span class="text mt-2">Customized tax savings for {{clientData.firstName + ' ' + clientData.lastName}}</span>
    </div>
  </div>
  <div class="row slide border slide-2 d-flex align-items-center" id="slide-2"
       *ngIf="slideLoaded && currentSlide == 'slide-2'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Disclaimer</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="disclaimer p-2">
        <p [innerHTML]="roiYear1Data.disclaimer"></p>
      </div>
    </div>
  </div>
  <div class="row slide border slide-3 d-flex align-items-center" id="slide-3"
       *ngIf="slideLoaded && currentSlide == 'slide-3'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Plan Design To Maximize</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <span><span class="blue-heading">The ROI Method™</span> Of Tax Planning</span>
      <div class="main-content d-flex justify-content-center align-items-center">
        <div class="org-name">{{orgName}}</div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-4 d-flex align-items-center" id="slide-4"
       *ngIf="slideLoaded && currentSlide == 'slide-4'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Clients & Results</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="caution p-1 mt-3">
        <i class="icon ion-android-bulb idea"></i>
        Savings is the diﬀerence between doing nothing & implementing advanced tax strategies tailored to your life.
      </div>
      <div class="p-1 mt-2" *ngIf="!readOnly">
        <span class="pointer float-right" style="margin-right: 10px" *ngIf="!isEditable"><a (click)="toggleEdit()">Edit</a></span>
        <span class="pointer float-right" style="margin-right: 10px" *ngIf="isEditable"><a (click)="toggleEdit()">View</a></span>
        <span class="pointer float-right" style="margin-right: 10px"><a (click)="savePresentationCustomValues()">Save</a></span>
      </div>
      <div class="mt-4" *ngIf="!isEditable">
        <div class="table-header d-flex justify-content-center align-items-center">
          <div></div>
          <div class="text-center">Investment</div>
          <div class="text-center">Projected Savings</div>
          <div class="text-center">Actual Savings</div>
        </div>
        <div class="d-flex justify-content-center align-items-center" *ngFor="let criteria of clientsAndResults,let i =index" [ngClass]="(i % 2 == 0) ? 'table-even-row' : 'table-odd-row'" >
          <div class="ps-2">{{criteria.clientName}}-</div>
          <div class="text-center">{{criteria.investment | formatAmount:'$0,0'}}</div>
          <div class="text-center">{{criteria.projectedSavings | formatAmount:'$0,0'}}</div>
          <div class="text-center">{{criteria.actualSavings | formatAmount:'$0,0'}}</div>
        </div>
      </div>
      <div class="mt-4" *ngIf="isEditable">
        <div class="row">
          <div class="column medium-12 text-right">
                  <span class="pointer" (click)="appendClient()">
                    <i class="material-icons manage-strategy-icon">add_circle_outline</i>
                  </span>
          </div>
          <div class="column medium-12">
            <div class="row" *ngFor="let criteria of clientsAndResults; let j=index">
              <div class="column medium-3">
                <input type="text" [(ngModel)]="criteria.clientName" placeholder="Client" style="height: 30px; font-size: 18px;"/>
              </div>
              <div class="column medium-3">
                <input type="text" [(ngModel)]="criteria.investment" placeholder="Investment" style="height: 30px; font-size: 18px;"/>
              </div>
              <div class="column medium-3">
                <input type="text" [(ngModel)]="criteria.projectedSavings" placeholder="Projected Savings" style="height: 30px; font-size: 18px;"/>
              </div>
              <div class="column medium-3">
                <input type="text" [(ngModel)]="criteria.actualSavings" placeholder="Actual Savings" style="height: 30px; font-size: 18px;display: inline;width: 80%"/>
                <span class="pointer delete-icon"><i class="icon ion-ios-trash float-right" style="margin-top: 5px;" (click)="deleteClientsResults(j)"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-5 d-flex align-items-center" id="slide-5"
       *ngIf="slideLoaded && currentSlide == 'slide-5'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Phases</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex justify-content-center align-items-center flex-column">
        <div class="d-flex justify-content-center align-items-center">
          <div class="phase d-flex justify-content-center align-items-center">
            <div class="phase-circle odd d-flex justify-content-center align-items-center flex-column">
              <div class="phase-title">Proposal</div>
            </div>
            <img src="../../../images/presentation/separator.png" class="separator"/>
          </div>
          <div class="phase d-flex justify-content-center align-items-center">
            <div class="phase-circle even d-flex justify-content-center align-items-center flex-column">
              <div class="phase-title">Planning</div>
            </div>
            <img src="../../../images/presentation/separator.png" class="separator"/>
          </div>
          <div class="phase d-flex justify-content-center align-items-center">
            <div class="phase-circle odd d-flex justify-content-center align-items-center flex-column">
              <div class="phase-title">Imple-mentation</div>
            </div>
            <img src="../../../images/presentation/separator.png" class="separator"/>
          </div>
          <div class="phase d-flex justify-content-center align-items-center">
            <div class="phase-circle even d-flex justify-content-center align-items-center">
              <div class="phase-title">Quarterly Reviews</div>
            </div>
            <img src="../../../images/presentation/separator.png" class="separator"/>
          </div>
          <div class="phase d-flex justify-content-center align-items-center">
            <div class="phase-circle odd d-flex justify-content-center align-items-center flex-column">
              <div class="phase-title">Annual Preparation</div>
            </div>
          </div>
        </div>
        <div class="justify-content-center align-items-center d-flex mt-2">
          <div class="phase-text">Present initial tax savings analysis and plan</div>
          <div class="phase-text">Finalize full tax plan with client</div>
          <div class="phase-text">Execute tax plan strategies</div>
          <div class="phase-text">Evaluate progress and adjust plan</div>
          <div class="phase-text">Prepare annual tax returns</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-6 d-flex align-items-center" id="slide-6"
       *ngIf="slideLoaded && currentSlide == 'slide-6'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">What you Keep</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="d-flex flex-column main-content mt-4">
        <div class="d-flex bar justify-content-between">
          <div>Tax Plan Savings {{planYear || ''}}</div>
          <div>{{year1Total | formatAmount:'$0,0'}}</div>
        </div>
        <div class="d-flex bar justify-content-between">
          <div>Tax Free Income</div>
          <div>{{actualTaxFreeIncome | formatAmount:'$0,0'}}</div>
        </div>
        <div class="d-flex bar justify-content-between total-amount">
          <div>Total Amount</div>
          <div>{{(year1Total + actualTaxFreeIncome)| formatAmount:'$0,0'}}</div>
        </div>
        <div class="d-flex bar justify-content-between">
          <div>Plan Investment</div>
          <div>{{actualYear1PlanFee | formatAmount:'$0,0'}}</div>
        </div>
        <div class="d-flex bar justify-content-between what-you-keep">
          <div>What you keep</div>
          <div>{{(year1Total + actualTaxFreeIncome - actualYear1PlanFee) | formatAmount:'$0,0'}}</div>
        </div>
        <div class="d-flex bar justify-content-between savings">
          <div>10 Year Savings</div>
          <div>{{(roiYear1Data? roiYear1Data.totalTaxSavings: 0) | formatAmount:'$0,0'}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-7 d-flex align-items-center" id="slide-7"
       *ngIf="slideLoaded && currentSlide == 'slide-7'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Year 1 Opportunities</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex justify-content-around align-items-center mt-5">
        <div *ngFor="let category of year1RoiCategories | slice:0:3;let i =index">
          <div class="opportunity first d-flex justify-content-center align-items-center flex-column" *ngIf="i == 0">
            <img src="../../../images/presentation/opp_icon1.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
          <div class="opportunity second d-flex justify-content-center align-items-center flex-column" *ngIf="i == 1">
            <img src="../../../images/presentation/opp_icon2.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
          <div class="opportunity third d-flex justify-content-center align-items-center flex-column" *ngIf="i == 2">
            <img src="../../../images/presentation/opp_icon3.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-8 d-flex align-items-center" id="slide-8"
       *ngIf="slideLoaded && currentSlide == 'slide-8'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Return On Investment</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex align-items-center mt-5">
        <div class="left d-flex flex-column">
          <div class="mt-2 investment">Your Investment - Year 1</div>
          <div class="mt-4 tax-savings p-3">Estimated Year 1 Tax Savings: {{roiYear1Data.categories[0].totalInfo.amount | formatAmount:'$0,0'}}</div>
          <div class="mt-3 investment-heading">Your investment in {{orgName}} Includes:</div>
          <div class="y1-costlines mt-2">
            <div class="roi-line" *ngFor="let costLine of roiYear1Data.costlines | slice:0:2;" style="margin:0 20px;">
              <div class="name float-left costline-item">{{costLine.description}}</div>
              <div class="text-right"  *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</div>
              <div class="text-right" *ngIf="costLine.type == 'Priceless'">Priceless</div>
            </div>
            <div class="roi-line" *ngIf="roiYear1Data.costlines && roiYear1Data.costlines.length > 2" style="margin-left: 35px;">
              <div class="name float-left">.... And more</div>
            </div>
          </div>
        </div>
        <div class="right d-flex flex-column align-items-center">
          <div class="net-savings mt-4">Net Year 1 Tax Savings</div>
          <div class="mt-4 potential-savings">Potential</div>
          <div class="mt-4 green-color">{{roiYear1Data.year1ProjectedGain | formatAmount:'$0,0'}}</div>
          <div class="mt-4 immediate-roi">IMMEDIATE ROI</div>
          <div class="mt-4 green-color">{{roiYear1Data.year1ROI}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-9 d-flex align-items-center" id="slide-9"
       *ngIf="slideLoaded && currentSlide == 'slide-9'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Year 2 Opportunities</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex justify-content-around align-items-center mt-5">
        <div *ngFor="let category of year2RoiCategories | slice:0:3;let i =index">
          <div class="opportunity first d-flex justify-content-center align-items-center flex-column" *ngIf="i == 0">
            <img src="../../../images/presentation/opp_icon1.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
          <div class="opportunity second d-flex justify-content-center align-items-center flex-column" *ngIf="i == 1">
            <img src="../../../images/presentation/opp_icon2.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
          <div class="opportunity third d-flex justify-content-center align-items-center flex-column" *ngIf="i == 2">
            <img src="../../../images/presentation/opp_icon3.PNG" />
            <div class="name mt-3">{{category.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-10 d-flex align-items-center" id="slide-10"
       *ngIf="slideLoaded && currentSlide == 'slide-10'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Return On Investment</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex align-items-center mt-5">
        <div class="left d-flex flex-column">
          <div class="mt-2 investment">Your Investment - Year 2</div>
          <div class="mt-4 tax-savings p-3">Estimated Year 2 Tax Savings: {{roiYear2Data.categories[0].totalInfo.amount | formatAmount:'$0,0'}}</div>
          <div class="mt-3 investment-heading">Your investment in {{orgName}} Includes:</div>
          <div class="y1-costlines mt-2">
            <div class="roi-line" *ngFor="let costLine of roiYear2Data.costlines | slice:0:2;" style="margin: 0 20px;">
              <div class="name float-left costline-item">{{costLine.description}}</div>
              <div class="text-right"  *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</div>
              <div class="text-right" *ngIf="costLine.type == 'Priceless'">Priceless</div>
            </div>
            <div class="roi-line" *ngIf="roiYear2Data.costlines && roiYear2Data.costlines.length > 2" style="margin-left: 35px;">
              <div class="name float-left">.... And more</div>
            </div>
          </div>
        </div>
        <div class="right d-flex flex-column align-items-center">
          <div class="net-savings mt-4">Net Year 2 Tax Savings</div>
          <div class="mt-4 potential-savings">Potential</div>
          <div class="mt-4 green-color">{{roiYear2Data.year1ProjectedGain | formatAmount:'$0,0'}}</div>
          <div class="mt-4 immediate-roi">IMMEDIATE ROI</div>
          <div class="mt-4 green-color">{{roiYear2Data.year1ROI}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-11 d-flex align-items-center" id="slide-11"
       *ngIf="slideLoaded && currentSlide == 'slide-11'">
    <div class="vertical-bar"></div>
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Return On Investment Over 10 Years</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="graph mt-3">
        <div *ngIf="hasROIGraphData" style="min-width: 300px;height:330px;">
          <highcharts-chart [Highcharts]="Highcharts" [options]="groupedROIChartOptions"
                            style="width: 100%; height: 330px; display: block"></highcharts-chart>
        </div>
      </div>
    </div>
  </div>
  <div class="row slide border slide-12 d-flex align-items-center" id="slide-12"
     *ngIf="slideLoaded && currentSlide == 'slide-12'">
  <div class="content">
    <div class="header d-flex justify-content-between">
      <span class="disclaimer-heading">Ready to Move Forward?</span>
      <div class="org-logo" [ngStyle]="logoBg"></div>
    </div>
    <div class="main-content">
      <div class="header d-flex">
        <div></div>
        <div>Investment*</div>
        <div>Pay IRS</div>
        <div>Keep</div>
      </div>
      <div class="option d-flex">
        <div class="option-text">No Tax Plan</div>
        <div class="dot-line"></div>
        <div class="value-wrapper"></div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option1Payus">
            <div>{{option1Payus | formatAmount: '$0,0'}}</div>
          </div>
        </div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option1PayIRS">
            <div>{{option1PayIRS | formatAmount: '$0,0'}}</div>
          </div>
        </div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option1Keep">
            <div>{{option1Keep | formatAmount: '$0,0'}}</div>
          </div>
        </div>
      </div>
      <div class="option d-flex">
        <div class="option-text">With Tax Plan</div>
        <div class="dot-line"></div>
        <div class="value-wrapper"></div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option2PayUs">
            <div>{{option2PayUs | formatAmount: '$0,0'}}</div>
          </div>
        </div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option2PayIRS">
            <div>{{option2PayIRS | formatAmount: '$0,0'}}</div>
          </div>
        </div>
        <div class="value-wrapper d-flex justify-content-center align-items-center">
          <div class="value d-flex" *ngIf="!editing.option2Keep">
            <div>{{option2Keep | formatAmount: '$0,0'}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-5" style="padding-top: 2rem;">*Investment is a combination of fees to the advisor plus third parties.</div>
  </div>
</div>
  <div class="row slide border slide-13 d-flex align-items-center" id="slide-13"
       *ngIf="slideLoaded && currentSlide == 'slide-13'">
    <div class="content">
      <div class="header d-flex justify-content-between">
        <span class="disclaimer-heading">Congratulations - Next Steps</span>
        <div class="org-logo" [ngStyle]="logoBg"></div>
      </div>
      <div class="main-content d-flex align-items-center justify-content-center">
        <div class="grid p-4 flex-column">
          <img class="icon" src="../../../images/presentation/last-icon1.png" />
          <div class="mt-3 heading">Engagement Letter</div>
          <div class="mt-2 mb-5 text">Send out engagement letter to confirm scope of services</div>
        </div>
        <div class="grid p-4 flex-column bg">
          <img class="icon" src="../../../images/presentation/last-icon2.png" />
          <div class="mt-3 heading">Onboarding Meeting</div>
          <div class="mt-2 mb-5 text">Schedule a kickoff meeting to align on goals and timeline</div>
        </div>
        <div class="grid p-4 flex-column">
          <img class="icon" src="../../../images/presentation/last-icon3.png" />
          <div class="mt-3 heading">Finalize The Tax Plan</div>
          <div class="mt-2 mb-5 text">Work together to finalize the optimal tax planning strategy</div>
        </div>
        <div class="grid p-4 flex-column bg">
          <img class="icon" src="../../../images/presentation/last-icon4.png" />
          <div class="mt-3 heading">Implementation</div>
          <div class="mt-2 mb-5 text">Execute the agreed upon tax planning techniques</div>
        </div>
      </div>
    </div>
  </div>
</div>

